

import {getDegrees, getExperiences, getIndustries, getSalaries, getScales, getStages} from "@/utils/job";

export default {
    name: "JdFilter",
    props: {
        experience: String | Number,
        degree: String | Number,
        salary: String | Number,
        stage: String | Number,
        scale: String | Number,
        industry: String | Number,
    },
    data() {
        return {
            experienceOptions: getExperiences(),
            degreeOptions: getDegrees(),
            salaryOptions: getSalaries(),
            stageOptions: getStages(),
            scaleOptions: getScales(),
            industryOptions: getIndustries(),

            experienceValue: this.experience,
            degreeValue: this.degree,
            salaryValue: this.salary,
            stageValue: this.stage,
            scaleValue: this.scale,
            industryValue: this.industry,
        }
    },
    methods: {
        onChangeExperience(value) {
            this.$emit("update:experience",value)
        },
        onChangeDegree(value) {
            this.$emit("update:degree",value)
        },
        onChangeSalary(value) {
            this.$emit("update:salary",value)
        },
        onChangeStage(value) {
            this.$emit("update:stage",value)
        },
        onChangeScale(value) {
            this.$emit("update:scale",value)
        },
        onChangeIndustry(value) {
            this.$emit("update:industry",value)
        },
    }
}
